import { LeadSource } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { BadgeColors, BadgeColorsProps } from '../components/Badge'
import { badgeColorByLeadSource, directLeadSources, leadSourceLabel } from '../constants'

const reviewLeadSourceLabel: Record<string, string> = {
  ...leadSourceLabel,
  ...directLeadSources.reduce(
    (labelsBySource, source) => {
      labelsBySource[source] = 'AvantStay'
      return labelsBySource
    },
    {} as Record<string, string>,
  ),
}

const reviewBadgeColorByLeadSource: Record<string, BadgeColorsProps> = {
  ...badgeColorByLeadSource,
  ...directLeadSources.reduce(
    (labelsBySource, source) => {
      labelsBySource[source] = BadgeColors.channelMobile
      return labelsBySource
    },
    {} as Record<string, BadgeColorsProps>,
  ),
}

export const getReviewLeadSource = (source: LeadSource) => ({
  label: reviewLeadSourceLabel[source],
  badgeColor: reviewBadgeColorByLeadSource[source],
})
